import addCustomInvestorGoalWizardLinkGoal from './add-custom-investor-goal-wizard-link-goal.json';
import successCreatedAndLinkedGoal from './success-created-and-linked-goal.json';

export default {
  ...addCustomInvestorGoalWizardLinkGoal,
  ...successCreatedAndLinkedGoal,
};
